var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"containerAgenda",attrs:{"id":"containerAnimations"}},[(0)?_c('div',[_c('div',{staticClass:"enjeu"}),_c('h2',[_vm._v("Pas d'évènement prévu")]),_c('div',{staticClass:"propositions",attrs:{"id":"Animations"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }